import React from "react";
import { ContextProviderComposer } from "../utils/ContextProvider";
import { AddonProvider } from "../contexts/AddonContext";
import { DialogProvider } from "../contexts/DialogContext";
import { FormProvider } from "../contexts/AddOnFormContext";
import { TenantProvider } from "../contexts/TenantContext";

export const AddonComposer = ({ children }) => {
  return (
    <ContextProviderComposer
      contextProviders={[
        <AddonProvider key={0} />,
        <FormProvider key={1} />,
        <TenantProvider key={2} />,
        <DialogProvider key={3} />,
      ]}
    >
      {children}
    </ContextProviderComposer>
  );
};
